import type { Region } from '@lt/api/dist/methods/references/types';
import type { HotelId } from '@lt/api/dist/types/hotels';
import { formatCurrency } from 'src/utils/stringUtils';

import type { TransformedHotelOffer } from '@lt/api/dist/methods/search/types';

interface geoHotelPointProps {
  hotelInfo: TransformedHotelOffer;
  viewedHotels: HotelId[];
}

export const hotelGeoPoint = ({
  hotelInfo,
  viewedHotels,
}: geoHotelPointProps) => {
  const { id, rating, price, long, lat } = hotelInfo;
  const isViewedHotels = viewedHotels.includes(Number(id));

  return {
    type: 'Feature',
    properties: {
      id,
      state: 'active',
      visited: isViewedHotels,
      price,
      rating: rating || 0,
      // дублируем координаты, для отображения попапа
      coordinates: [long, lat],
    },
    geometry: {
      type: 'Point',
      coordinates: [long, lat],
    },
  };
};

export const regionGeoPoint = (region: Region) => ({
  type: 'Feature',
  properties: {
    kind: 'City',
    ancestry_depth: 4,
    name: region.name,
    price_range: region.price ? formatCurrency(region.price) : '',
    // дублируем координаты, чтобы иметь к ним доступ
    coordinates: region.coordinates,
  },
  geometry: {
    type: 'Point',
    coordinates: region.coordinates,
  },
});
